import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlNetworkManagement extends Layout {
    panelNetworkSection: Panel;
    sourceMCControl: DataSource;
    textboxClientPort: Textbox;
    textboxIpHost: Textbox;
    textboxMcleodServer: Textbox;
    textboxProxyServer: Textbox;
    textboxQueueName: Textbox;
    textboxServerPort: Textbox;
    textboxWebPage: Textbox;
}
